import React, { useState } from "react";
import { bottom, info, logo, person, top } from "../assets/icons";
import { Link } from "react-router-dom";
import { findMyUrl } from "../API/axios";
import { Notify } from "../utils/helpfunctions";

function Login() {
  const [loading, setLoading] = useState(null);
  const [email, setEmail] = useState("");
  const [url, setUrl] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading("submit");

    await findMyUrl(email)
      .then((res) => {
        if (res.data.url) {
          setUrl(res.data.url);
        } else {
          Notify(res.data.message, "error");
        }
      })
      .catch((error) => {
        Notify(error.message, "error");
        console.log(error);
      });

    setLoading(null);
  };

  return (
    <div className="relative w-full h-screen bg-gradient-to-br from-teal/50 to-purp/50 flex items-end">
      <div className="absolute top-0 left-0">{top}</div>
      <div className="absolute bottom-0 right-0">{bottom}</div>

      <div className="fixed inset-0 text-center mt-2 md:mt-4 ml-4 md:ml-8 w-[200px] h-fit z-[5]">
        <Link to="/hrm" className="text-white">
          {logo}
        </Link>
      </div>

      <div className="w-[700px] lg:w-[800px] xl:w-[900px] hidden h-full md:flex items-end pl-8">
        {person}
      </div>

      <div className="md:absolute right-16 w-full md:w-fit h-full flex items-center justify-center p-4 smd:p-8">
        <form
          onSubmit={handleSubmit}
          className="w-full smd:w-[350px] h-fit bg-white rounded-xl shadow-md flex flex-col gap-4 p-4 smd:px-8 py-12"
        >
          <h1 className="text-xl font-medium">Find Your Synapsivate</h1>

          <div className="text-sm text-gray-400 border rounded-md p-2 mb-2 flex items-center gap-4">
            <div className="min-w-[24px] max-w-[24px] p-0.5">{info}</div>
            <p className="leading-tight">
              Enter your email to find your organization's cloud installation.
            </p>
          </div>

          <div className="w-full flex flex-col gap-1 text-gray-500">
            <label htmlFor="email" className="flex items-center gap-1">
              <p>Email</p>
              <span className="w-fit text-red-700">*</span>
            </label>

            <input
              type="email"
              name="email"
              id="email"
              required
              placeholder="example@gmail.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="px-2.5 py-1.5 border rounded-md placeholder:text-gray-300 outline-none focus:border-blue-500 focus:ring-1 ring-blue-500 duration-500"
            />
          </div>

          <div className="w-full h-[50px] flex items-center justify-center">
            {loading === "submit" ? (
              <div className="size-6 rounded-full border-2 border-blue-500 border-t-transparent animate-spin"></div>
            ) : (
              <button
                disabled={url}
                className="w-full h-fit px-4 py-1.5 bg-teal/90 hover:bg-teal text-white rounded-md font-medium self-end"
              >
                Find
              </button>
            )}
          </div>

          {url && (
            <div className="w-full flex gap-1">
              <h1>URL: </h1>
              <a
                href={`https://${url}.synapsivate.com`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 underline"
              >
                {`https://${url}.synapsivate.com`}
              </a>
            </div>
          )}

          <div className="w-full flex gap-1 justify-end text-right text-xs">
            <h1>Don't have account ?</h1>
            <Link to="/hrm/signup" className="font-bold text-teal underline">
              Sign Up Here
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Login;
